export default {
  _prefix: "https://webapi.amap.com/maps",
  _disableMapCache: !1,
  verbose: !1,
  timing: !1,
  version: "2.0",
  key: "",
  plugins: [],
  PACKAGE_VERSION: "0.1.3"
};